import {
  AccountClient,
  GET_PERSONALIZATION_BY_NAME,
  SAVE_PERSONALIZATION
} from '@nile/graphql/src';
import { getCurrentUserHook } from '@nile/components';

const ColumnPersonalization = () => {
  const user = getCurrentUserHook();

  const saveColumnPersonalization = (params) => {
    if (params) {
      return AccountClient.mutate({
        mutation: SAVE_PERSONALIZATION,
        variables: params.variables,
        update(cache, { data }) {
          // const { category, name } = variables; // Extract from mutation variables
          let personalisedData = cache.readQuery({
            query: GET_PERSONALIZATION_BY_NAME,
            variables: {
              userId: user?.userId,
              category: `${params.module?.toLowerCase()}-columnPersonilsation`,
              name: params.viewId || 'columnPersonilsation'
            }
          });
          cache.writeQuery({
            query: GET_PERSONALIZATION_BY_NAME,
            data: {
              getPersonalizationByCategoryAndName: {
                ...personalisedData?.getPersonalizationByCategoryAndName,
                value: JSON.stringify(params.columnData)
              }
            }
          });
        }
      });
    }
  };

  return { saveColumnPersonalization };
};
export default ColumnPersonalization;
